import React, { Component } from 'react'

class Settings extends Component {
  render() {
    return (
      <h4>
        Settings
      </h4>
    )
  }
}

export default Settings;